import React from 'react'
import type { ReactElement, ChangeEvent } from 'react'
import { BasketItemModel } from './types/models'

type BasketQuantityProps = {
  item: BasketItemModel;
  onQuantityChanged: (id: number, qty: string) => void;
}

const BasketQuantity = ({ item, onQuantityChanged }: BasketQuantityProps): ReactElement => (
  <>
    <button
      type="button"
      className="product-decrement-quantity basket-qty-change"
      aria-label="remove"
      onClick={(): void => {
        onQuantityChanged(item.id, String(item.quantity - 1))
      }}
      disabled={item.quantity === null}
    >
    </button>
    <input
      className="product-qty-input"
      type="text"
      name={`qty[${item.id}]`}
      inputMode="numeric"
      pattern="[0-9]*"
      value={item.quantity || ''}
      onChange={
        (event: ChangeEvent<HTMLInputElement>): void => {
          onQuantityChanged(item.id, event.target.value)
        }
      }
      aria-label="Quantity"
    />
    <button
      type="button"
      className="product-increment-quantity basket-qty-change"
      aria-label="add"
      onClick={(): void => {
        onQuantityChanged(item.id, String(item.quantity + 1))
      }}
    >
    </button>
  </>
)

export default BasketQuantity
